export default {"src":"/_next/static/media/piggyBank_40.468a9eb2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};